import React, { Component } from 'react'
import Card from '../Card'
import UserLinks from '../UserLinks'
import './UserInfo.scss'
import {GatsbyImage, getImage} from "gatsby-plugin-image";

class UserInfo extends Component {
  render() {
    const { author, userImages } = this.props
    const userImageNodeList = userImages.filter(fileNode => {
      if (fileNode.node.childImageSharp === null) return false

      if (fileNode.node.relativePath === author.image.url) return true

      return false
    })

    let userImage
    if (userImageNodeList.length === 1) {
      userImage = (
        <GatsbyImage
          image={getImage(userImageNodeList[0].node.childImageSharp)}
          role="presentation"
         alt="user info"/>
      )
    } else {
      userImage = <img src={author.image.url} role="presentation" />
    }

    return (
      <Card>
        <h3 className="written-by">Authored by</h3>
        <div className="user-info">
          <div className="user">
            {userImage}
            <p>{author.full_name && author.full_name}</p>
            <p className="role">{author.role}</p>
          </div>
          <div className="user-bio">
            <span
              dangerouslySetInnerHTML={{ __html: author.short && author.short }}
            />
            {/*{userLinksElement}*/}
          </div>
        </div>
      </Card>
    )
  }
}

export default UserInfo
